"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.del = exports.patch = exports.put = exports.post = exports.read = void 0;

var _flow2 = _interopRequireDefault(require("lodash/fp/flow"));

var _keys2 = _interopRequireDefault(require("lodash/fp/keys"));

var _isObject2 = _interopRequireDefault(require("lodash/fp/isObject"));

var _prop2 = _interopRequireDefault(require("lodash/fp/prop"));

var _any2 = _interopRequireDefault(require("lodash/fp/any"));

var _queryString = require("query-string");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var File = global.File;

var commonFetch = function (method, url, data, options) {
  var body;

  var headers = __assign({
    'content-type': 'application/json'
  }, (0, _prop2.default)('headers')(options));

  if (File && (0, _isObject2.default)(data) && (0, _flow2.default)(_keys2.default, (0, _any2.default)(function (key) {
    return data[key] instanceof File;
  }))(data)) {
    body = new FormData();
    Object.keys(data).forEach(function (key) {
      body.append(key, data[key]);
    });
    headers = {};
  } else if (data) {
    body = JSON.stringify(data);
  }

  return __assign(__assign({}, options), {
    url: url,
    isApi: true,
    method: method,
    headers: headers,
    body: body
  });
};

var read = function (url, query, options) {
  return commonFetch('GET', query ? url + "?" + (0, _queryString.stringify)(query) : url, undefined, options);
};

exports.read = read;

var post = function (url, data, options) {
  return commonFetch('POST', url, data, options);
};

exports.post = post;

var put = function (url, data, options) {
  return commonFetch('PUT', url, data, options);
};

exports.put = put;

var patch = function (url, data, options) {
  return commonFetch('PATCH', url, data, options);
};

exports.patch = patch;

var del = function (url, query, options) {
  return commonFetch('DELETE', query ? url + "?" + (0, _queryString.stringify)(query) : url, undefined, options);
};

exports.del = del;